import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextInput,
} from "app/common/renderInput";
import Tooltip from "rc-tooltip";
import { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { FaArrowRight, FaEdit, FaInfoCircle } from "react-icons/fa";
import { MdDelete, MdDeleteForever } from "react-icons/md";
import countryData from "../countryCode.json";
import { duplicatePaxCheck } from "app/services/bookingService";
import TimeDeparture from "./TimeDeparture";
const PaxCard = ({
  index,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  tripType,
  arrayHelpers,
  array,
  setFieldValue,
  calculateSSRAmount,
}) => {
  const [country, setCountry] = useState(countryData);
  const PtList = [
    { value: "ADULT", label: "Adult" },
    { value: "CHILD", label: "Child" },
    { value: "INFANT", label: "Infant" },
  ];

  const getTitleOptions = (pt) => {
    switch (pt) {
      case "ADULT":
        return [
          { value: "Mr", label: "Mr" },
          { value: "Mrs", label: "Mrs" },
          { value: "Ms", label: "Ms" },
        ];

      case "CHILD":
        return [
          { value: "Master", label: "Master" },
          { value: "Miss", label: "Miss" },
        ];

      case "INFANT":
        return [
          { value: "Master", label: "Master" },
          { value: "Miss", label: "Miss" },
        ];

      default:
        return [];
    }
  };
  const refundableOption = [
    { value: 1, label: "Refundable" },
    { value: 2, label: "Partial Refundable" },
    { value: 0, label: "Non Refundable" },
  ];
  const cabinClassOption = [
    { value: "ECONOMY", label: "Economy" },
    { value: "PREMIUM ECONOMY", label: "Premium Economy" },
    { value: "BUSINESS", label: "Business" },
    { value: "PREMIUM BUSINESS", label: "Premium Business" },
    { value: "FIRST", label: "First" },
  ];
  const [show, setShow] = useState(false);
  const [modalIndex, setModalIndex] = useState(null);
  const [initialModalValues, setInitialModalValues] = useState(null);
  const [noChangeError, setNoChangeError] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);

  const handleShow = (idx, values) => {
    debugger;
    setModalIndex(idx);

    const snapshot = {
      departureDate: values?.flightLegs?.return[0]?.departureDate,
      departureTime: values?.flightLegs?.return[0]?.departureTime,
      pnr: values?.flightLegs?.return[0]?.pnr,
      firstName: values?.pax?.return[idx]?.fN,
      lastName: values?.pax?.return[idx]?.lN,
    };

    setInitialModalValues(snapshot);
    setNoChangeError(false);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setNoChangeError(false);
  };

  const hasModalValuesChanged = () => {
    if (modalIndex === null || !initialModalValues) return false;

    const currentValues = {
      departureDate: values?.flightLegs?.return[0]?.departureDate,
      departureTime: values?.flightLegs?.return[0]?.departureTime,
      pnr: values?.flightLegs?.return[0]?.pnr,
      firstName: values?.pax?.return[modalIndex]?.fN,
      lastName: values?.pax?.return[modalIndex]?.lN,
    };

    return Object.keys(initialModalValues).some(
      (key) => initialModalValues[key] !== currentValues[key],
    );
  };

  const handleSave = () => {
    const isChanged = hasModalValuesChanged();

    if (isChanged) {
      setShow(false);
      setNoChangeError(false);
    } else {
      setNoChangeError(true);
    }
  };

  ///////////////////Extra Baggage//////////////////////
  const [baggage, setBaggage] = useState(""); // Current baggage name
  const [amountBag, setAmountBag] = useState(Number(0).toFixed(2)); // Current amount value
  const [extraBags, setExtraBags] = useState([]); // List of baggage & amounts
  const [editIndexBag, setEditIndexBag] = useState(null); // Track which index is being edited

  // Add new or update existing baggage item
  const handleAddOrUpdateBag = () => {
    if (baggage.trim() && amountBag >= 0) {
      let updatedBags = [...extraBags];
      const baggageInfo = {
        code: baggage,
        amount: Number(amountBag).toFixed(2),
      };
      if (editIndexBag !== null) {
        // Update existing entry

        updatedBags[editIndexBag] = baggageInfo;
        setEditIndexBag(null); // Exit edit mode
      } else {
        // Add new entry
        updatedBags = [...extraBags, baggageInfo];
      }

      // Immediately set updated array into Formik field
      setFieldValue(`pax.return[${index}].extraBag`, updatedBags);

      // Update local state
      setExtraBags(updatedBags);

      // Clear input fields
      setBaggage("");
      setAmountBag(Number(0).toFixed(2));
    }
  };

  // Edit button - populate inputs with selected baggage
  const handleEditBag = (index) => {
    const bag = extraBags[index];
    setBaggage(bag.code);

    setAmountBag(Number(bag.amount).toFixed(2));
    setEditIndexBag(index); // Track which item is being edited
  };

  // Remove baggage item
  const handleRemoveBag = (index) => {
    const filteredBags = extraBags.filter((_, i) => i !== index);
    setExtraBags(filteredBags);
    if (editIndexBag === index) {
      setBaggage("");
      setAmountBag(Number(0).toFixed(2));
      setEditIndexBag(null);
    }
    setFieldValue(`pax.return[${index}].extraBag`, filteredBags);
  };

  //////////////////////Seat/////////////////////////////

  const [seat, setSeat] = useState(""); // Current seat name (e.g., Seat Number)
  const [seatAmount, setSeatAmount] = useState(Number(0).toFixed(2)); // Current seat amount
  const [extraSeats, setExtraSeats] = useState([]); // List of seats & amounts
  const [editIndexSeat, setEditIndexSeat] = useState(null); // Track which seat index is being edited

  // Add or update seat entry
  const handleAddOrUpdateSeat = () => {
    if (seat.trim() && seatAmount >= 0) {
      let updatedSeats = [...extraSeats];
      const seatInfo = {
        code: seat,
        amount: Number(seatAmount).toFixed(2),
      };

      if (editIndexSeat !== null) {
        // Update existing seat
        updatedSeats[editIndexSeat] = seatInfo;
        setEditIndexSeat(null); // Exit edit mode
      } else {
        // Add new seat
        updatedSeats = [...extraSeats, seatInfo];
      }

      // Update Formik field for pax return
      setFieldValue(`pax.return[${index}].seat`, updatedSeats);

      // Update local state
      setExtraSeats(updatedSeats);

      // Clear inputs
      setSeat("");
      setSeatAmount(Number(0).toFixed(2));
    }
  };

  // Edit seat button - populate inputs with selected seat
  const handleEditSeat = (index) => {
    const selectedSeat = extraSeats[index];
    setSeat(selectedSeat.code);
    setSeatAmount(Number(selectedSeat.amount).toFixed(2));
    setEditIndexSeat(index);
  };

  // Remove seat entry
  const handleRemoveSeat = (index) => {
    const filteredSeats = extraSeats.filter((_, i) => i !== index);
    setExtraSeats(filteredSeats);

    if (editIndexSeat === index) {
      setSeat("");
      setSeatAmount(Number(0).toFixed(2));
      setEditIndexSeat(null);
    }

    // Update Formik field after deletion
    setFieldValue(`pax.return[${index}].seat`, filteredSeats);
  };
  ///////////MEAl//////////////////////////
  // Food State Management
  const [food, setFood] = useState(""); // Current food name
  const [amountFood, setAmountFood] = useState(Number(0).toFixed(2)); // Current food amount
  const [extraFoods, setExtraFoods] = useState([]); // List of foods & amounts
  const [editIndexFood, setEditIndexFood] = useState(null); // Track which food is being edited

  // Add or Update Food Item
  const handleAddOrUpdateFood = () => {
    if (food.trim() && amountFood >= 0) {
      let updatedFoods = [...extraFoods];
      const foodInfo = {
        code: food,
        amount: Number(amountFood).toFixed(2),
      };
      if (editIndexFood !== null) {
        // Update existing food item
        updatedFoods[editIndexFood] = foodInfo;
        setEditIndexFood(null); // Exit edit mode
      } else {
        // Add new food item
        updatedFoods = [...extraFoods, foodInfo];
      }

      // Immediately set updated food list into Formik field
      setFieldValue(`pax.return[${index}].food`, updatedFoods);

      // Update local state
      setExtraFoods(updatedFoods);

      // Clear input fields
      setFood("");
      setAmountFood(Number(0).toFixed(2));
    }
  };

  // Edit Food Item
  const handleEditFood = (index) => {
    const foodItem = extraFoods[index];
    setFood(foodItem.code);
    setAmountFood(Number(foodItem.amount).toFixed(2));
    setEditIndexFood(index);
  };

  // Remove Food Item
  const handleRemoveFood = (index) => {
    const filteredFoods = extraFoods.filter((_, i) => i !== index);
    setExtraFoods(filteredFoods);

    // Update Formik field
    setFieldValue(`pax.return[${index}].food`, filteredFoods);

    // Clear edit mode if removing the currently edited item
    if (editIndexFood === index) {
      setFood("");
      setAmountFood(Number(0).toFixed(2));
      setEditIndexFood(null);
    }
  };

  ///////////FAST FORWARD//////////////////////////
  // FAST State Management
  const [fastForward, setFastForward] = useState(""); // Current fats name
  const [amountFast, setAmountFast] = useState(Number(0).toFixed(2)); // Current fast amount
  const [extraFasts, setExtraFasts] = useState([]); // List of fasts & amounts
  const [editIndexFast, setEditIndexFast] = useState(null); // Track which fast is being edited

  // Add or Update fats Item
  const handleAddOrUpdateFast = () => {
    if (amountFast.trim() && amountFast >= 0) {
      let updatedFasts = [...extraFasts];
      const fastInfo = {
        code: fastForward,
        amount: Number(amountFast).toFixed(2),
      };
      if (editIndexFast !== null) {
        // Update existing fast item
        updatedFasts[editIndexFast] = fastInfo;
        setEditIndexFast(null); // Exit edit mode
      } else {
        // Add new fast item
        updatedFasts = [...extraFasts, fastInfo];
      }

      // Immediately set updated fast list into Formik field
      setFieldValue(`pax.return[${index}].fast`, updatedFasts);

      // Update local state
      setExtraFasts(updatedFasts);

      // Clear input fields
      setFastForward("");
      setAmountFast(Number(0).toFixed(2));
    }
  };

  // Edit fast Item
  const handleEditFast = (index) => {
    const fastItem = extraFasts[index];
    setFastForward(fastItem.code);
    setAmountFast(Number(fastItem.amount).toFixed(2));
    setEditIndexFast(index);
  };

  // Remove fats Item
  const handleRemoveFast = (index) => {
    const filteredFasts = extraFasts.filter((_, i) => i !== index);
    setExtraFasts(filteredFasts);

    // Update Formik field
    setFieldValue(`pax.return[${index}].fast`, filteredFasts);

    // Clear edit mode if removing the currently edited item
    if (editIndexFast === index) {
      setFastForward("");
      setAmountFast(Number(0).toFixed(2));
      setEditIndexFast(null);
    }
  };

  const DuplicateChecking = useCallback(async (values, index) => {
    const paxList = values?.pax?.return || [];
    const departureDate = `${values?.flightLegs?.return?.[0]?.departureDate}T${values?.flightLegs?.return?.[0]?.departureTime}:00.000Z`;
    const pnr = values?.flightLegs?.return?.[0]?.pnr;
    const memId = values?.affiliateName || 0;

    if (!departureDate || !pnr || !memId) return false;

    // for (let i = 0; i < paxList.length; i++) {
    const pax = paxList[index];
    const first = pax?.fN?.trim();
    const last = pax?.lN?.trim();

    if (!first || !last) return;

    const request = {
      departureDate,
      memId,
      pnr,
      psnFirstName: first,
      psnLastName: last,
    };

    try {
      const res = await duplicatePaxCheck(request);

      if (res?.status === "Error") {
        debugger;
        handleShow(index, values); // ✅ pass index
        const result = res?.data?.split("_").map((item) => item.trim());
        setDuplicateData({
          pnr: result[0] ?? "",
          bookingId: result[1] ?? "",
        });
        return true;
      }
    } catch (err) {
      console.error("Duplicate API error", err);
    }
    // }

    return false;
  }, []);
  useEffect(() => {
    const paxList = values?.pax?.return || [];

    const hasValidPax = paxList.some((p) => p?.fN?.trim() && p?.lN?.trim());

    const hasRequiredFields =
      values?.flightLegs?.return?.[0]?.departureDate &&
      values?.flightLegs?.return?.[0]?.departureTime &&
      values?.flightLegs?.return?.[0]?.pnr &&
      values?.affiliateName;

    if (!hasValidPax || !hasRequiredFields) return;

    const timer = setTimeout(async () => {
      const isDuplicate = await DuplicateChecking(values, index);

      if (isDuplicate) {
        console.log("🚨 Duplicate passenger found");
      }
    }, 500); // ⏱ debounce delay

    return () => clearTimeout(timer); // cancel previous timer while typing
  }, [
    values?.pax?.return?.map((p) => `${p?.fN}-${p?.lN}`).join("|"),
    values?.flightLegs?.return?.[0]?.departureDate,
    values?.flightLegs?.return?.[0]?.pnr,
    values?.affiliateName,
  ]);

  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        <Col>
          <div style={{ fontSize: 15, fontWeight: "bold" }}>
            Passenger -{index + 1} (
            {values?.pax?.return[index]?.pt == null
              ? "Adult"
              : values?.pax?.return[index]?.pt}
            )
          </div>
        </Col>

        {/* disabled={index == array.length - 1 ? false : true} */}
        {index > 0 && (
          <Col xs="6">
            {/* {index == array.length - 1 && ( */}
            <div className="d-flex justify-content-end ">
              <Button
                variant="danger"
                type="button"
                onClick={() => {
                  arrayHelpers.remove(index);
                }}
              >
                <MdDelete color="white" size={20} />
              </Button>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <RenderSelectInput
            type="text"
            name={`pax.return[${index}].refundable`}
            display="Refundable Or Not"
            value={values?.pax?.return[index]?.refundable}
            items={refundableOption}
            onChange={(e) =>
              setFieldValue(`pax.return[${index}].refundable`, e.target.value)
            }
            // error={errors?.pax?.return?.[index]?.refundable}
            // touched={touched?.pax?.return?.[index]?.refundable}
            required
          ></RenderSelectInput>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <RenderSelectInput
            type="text"
            name={`pax.return[${index}].cc`}
            display={"Cabin Class"}
            value={values?.pax?.return[index]?.cc}
            items={cabinClassOption}
            onChange={handleChange}
            error={errors?.pax?.return?.[index]?.cc}
            touched={touched?.pax?.return?.[index]?.cc}
            required
          ></RenderSelectInput>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <label>Class of Booking</label>

            <input
              className="form-control"
              type="text"
              placeholder="Class of Booking"
              name={`pax.return[${index}].cB`}
              value={values?.pax?.return[index]?.cB}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <label>Ticket No.</label>

            <input
              className="form-control"
              type="text"
              placeholder="Ticket No."
              name={`pax.return[${index}].ticketNo`}
              value={values?.pax?.return[index]?.ticketNo}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>
              Pax Type <span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -25 }}>
              <RenderSelectInput
                type="text"
                name={`pax.return[${index}].pt`}
                value={values?.pax?.return[index]?.pt}
                onChange={handleChange}
                items={PtList}
                error={errors?.pax?.return?.[index]?.pt}
                touched={touched?.pax?.return?.[index]?.pt}
              ></RenderSelectInput>
              {/* {touched?.pax?.return[index]?.pt &&
              errors?.pax?.return[index]?.pt ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.pt}
                </div>
              ) : (
                ""
              )} */}
            </Row>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>
              Title <span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -25 }}>
              <RenderSelectInput
                type="text"
                name={`pax.return[${index}].ti`}
                value={values?.pax?.return[index]?.ti}
                onChange={handleChange}
                items={getTitleOptions(values?.pax?.onward[index]?.pt)}
                error={errors?.pax?.return?.[index]?.ti}
                touched={touched?.pax?.return?.[index]?.ti}
                // required
              ></RenderSelectInput>
              {/* {touched?.pax?.return?.[index]?.ti &&
              errors?.pax?.return[index]?.ti ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.ti}
                </div>
              ) : (
                ""
              )} */}
            </Row>
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>
              First Name <span className="text-danger">*</span>
            </Form.Label>
            <input
              style={{ marginTop: -3 }}
              className="form-control"
              type="text"
              placeholder="First Name"
              name={`pax.return[${index}].fN`}
              value={values?.pax?.return[index]?.fN}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.fN &&
            errors?.pax?.return[index]?.fN ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.pax?.return[index]?.fN}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>
              Last Name <span className="text-danger">*</span>
            </Form.Label>
            <input
              style={{ marginTop: -3 }}
              className="form-control"
              type="text"
              placeholder="Last Name"
              name={`pax.return[${index}].lN`}
              value={values?.pax?.return[index]?.lN}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.lN &&
            errors?.pax?.return[index]?.lN ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.pax?.return[index]?.lN}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      {values?.flightType == "International" && (
        <Row>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                DOB <span className="text-danger">*</span>
              </Form.Label>
              <Row style={{ marginTop: -25, marginBottom: -15 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].dob`}
                  value={values?.pax?.return[index]?.dob}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>
              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.dob &&
              errors?.pax?.return[index]?.dob ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.dob}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                Passport Number <span className="text-danger">*</span>
              </Form.Label>
              <Row style={{ marginTop: -25, marginBottom: -15 }}>
                <RenderTextInput
                  className="form-control"
                  type="text"
                  placeholder="Passport Number"
                  name={`pax.return[${index}].pNum`}
                  value={values?.pax?.return[index]?.pNum}
                  onChange={handleChange}
                />
              </Row>
              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.pNum &&
              errors?.pax?.return[index]?.pNum ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.pNum}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>

          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                Passport Issue Date <span className="text-danger">*</span>{" "}
              </Form.Label>
              <Row style={{ marginTop: -25, marginBottom: -15 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].pid`}
                  value={values?.pax?.return[index]?.pid}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>

              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.pid &&
              errors?.pax?.return[index]?.pid ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.pid}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>
                Passport Expiry Date <span className="text-danger">*</span>
              </Form.Label>
              <Row style={{ marginTop: -25, marginBottom: -15 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].eD`}
                  value={values?.pax?.return[index]?.eD}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>

              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.eD &&
              errors?.pax?.return[index]?.eD ? (
                <div
                  type="invalid"
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  {errors?.pax?.return[index]?.eD}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
        </Row>
      )}
      <Row>
        {values?.flightType == "International" && (
          <Col
            xs="12"
            md="6"
            lg={
              tripType == 2 || tripType == 3
                ? values?.flightType == "International"
                  ? "6"
                  : "12"
                : values?.flightType == "International"
                  ? "3"
                  : "4"
            }
          >
            <Form.Label>Passport Nationality</Form.Label>
            <select
              className="form-control"
              name={`pax.return[${index}].pNat`}
              value={values?.pax?.return[index]?.pNat}
              onChange={(e) => {
                debugger;
                handleChange(e);
              }}
              onBlur={handleBlur}
            >
              {country?.map((h, i) => (
                <option key={i} value={h.name}>
                  {h.name} - {h.code}
                </option>
              ))}
            </select>
          </Col>
        )}

        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3">
            <Form.Label>Cabin Baggage</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Cabin Baggage"
              name={`pax.return[${index}].cabinBag`}
              value={values?.pax?.return[index]?.cabinBag}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.cabinBag &&
            errors?.pax?.return[index]?.cabinBag ? (
              <div className="error-label">
                {errors.pax?.return[index]?.cabinBag}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Checking Baggage</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Checking Baggage"
              name={`pax.return[${index}].checkingBag`}
              value={values?.pax?.return[index]?.checkingBag}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.checkingBag &&
            errors?.pax?.return[index]?.checkingBag ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.checkingBag}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col
          xs="12"
          md="6"
          lg={
            tripType == 2 || tripType == 3
              ? values?.flightType == "International"
                ? "6"
                : "12"
              : values?.flightType == "International"
                ? "4"
                : "4"
          }
        >
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Frequent Flyer Number</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Frequent Flyer Number"
              name={`pax.return[${index}].ff`}
              value={values?.pax?.return[index]?.ff}
              onChange={handleChange}
            />
            {/* {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.ff &&
            errors?.pax?.return[index]?.ff ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.ff}{" "}
              </div>
            ) : (
              ""
            )} */}
          </Form.Group>
        </Col>
        {values?.pax?.return[index]?.pt != "INFANT" && (
          <>
            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                    ? "3"
                    : "3"
              }
            >
              <Form.Group className="mb-3">
                <Form.Label>Seat & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Seat Number"
                    value={seat}
                    onChange={(e) => setSeat(e.target.value)}
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={seatAmount}
                    onChange={(e) => setSeatAmount(e.target.value)}
                  />
                  {extraSeats.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Seats</h6>

                            {extraSeats.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditSeat(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveSeat(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateSeat();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length ===
                        extraSeats.length && editIndexSeat === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                    ? "4"
                    : "3"
              }
            >
              <Form.Group className="mb-3">
                <Form.Label>Fast Forward & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Fast Forward"
                    value={fastForward}
                    onChange={(e) => setFastForward(e.target.value)}
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={amountFast}
                    onChange={(e) => setAmountFast(e.target.value)}
                  />
                  {extraFasts.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Fast Forward</h6>

                            {extraFasts.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditFast(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveFast(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateFast();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length ===
                        extraFasts.length && editIndexFast === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                    ? "6"
                    : "6"
              }
            >
              <Form.Group className="mb-3">
                <Form.Label>Meal & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Meal"
                    value={food}
                    onChange={(e) => setFood(e.target.value)}
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={amountFood}
                    onChange={(e) => setAmountFood(e.target.value)}
                  />
                  {extraFoods.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Meals</h6>

                            {extraFoods.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditFood(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveFood(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateFood();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length ===
                        extraFoods.length && editIndexFood === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>

            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                    ? "6"
                    : "6"
              }
            >
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Extra Baggage & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    value={baggage}
                    onChange={(e) => setBaggage(e.target.value)}
                    placeholder="Baggage"
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={amountBag}
                    onChange={(e) => setAmountBag(e.target.value)}
                  />
                  {extraBags.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Extra Baggages</h6>

                            {extraBags.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditBag(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveBag(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateBag();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length === extraBags.length &&
                      editIndexBag === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
          </>
        )}

        {values?.pax?.return[index]?.pt != "INFANT" && (
          <Col
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
              paddingTop: 5,
            }}
          >
            <label style={{ cursor: "pointer", marginTop: 10 }}>
              <input
                className={`form-check-input border-primary`}
                type="checkbox"
                placeholder="Food"
                name={`pax.return[${index}].Wheelchair`}
                value={values.pax.return[index].Wheelchair}
                onChange={handleChange}
              />{" "}
              <span style={{ fontWeight: "bold" }}>Wheelchair</span>
            </label>
          </Col>
        )}
      </Row>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            Duplicate entry exists against Pax {index + 1}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {duplicateData?.pnr && duplicateData?.bookingId && (
              <Col
                xs="12"
                md="12"
                className="border border-1 border-primary rounded p-1 mb-1"
              >
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <small className="text-muted">PNR</small>
                    <div className="fw-bold fs-12 text-primary">
                      {duplicateData?.pnr}
                    </div>
                  </div>

                  <div>
                    <small className="text-muted">Booking ID</small>
                    <div className="fw-bold fs-12 text-success">
                      {duplicateData?.bookingId}
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Col xs="12" md="6">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>
                  Departure Date <span className="text-danger">*</span>{" "}
                </Form.Label>
                <div
                  style={{
                    marginTop: -22,
                    marginBottom: -10,
                  }}
                >
                  <RenderDateInput
                    type="date"
                    name={`flightLegs.return[${0}].departureDate`}
                    value={values?.flightLegs?.return[0]?.departureDate || ""}
                    onChange={handleChange}
                  ></RenderDateInput>
                </div>

                {touched?.flightLegs?.return &&
                touched.flightLegs.return[0]?.departureDate &&
                errors?.flightLegs?.return &&
                errors.flightLegs.return[0]?.departureDate ? (
                  <div
                    type="invalid"
                    style={{
                      fontSize: "10px",
                      color: "red",
                    }}
                  >
                    {errors?.flightLegs?.return[0]?.departureDate}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            <Col xs="12" md="6">
              <Form.Group controlId="formBasicEmail">
                <Form.Label>
                  Departure Time <span className="text-danger">*</span>
                </Form.Label>
                <TimeDeparture
                  index={0}
                  values={values}
                  handleChange={handleChange}
                />
                {touched?.flightLegs?.return &&
                errors?.flightLegs?.return &&
                touched?.flightLegs?.return[0]?.departureTime &&
                errors?.flightLegs?.return[0]?.departureTime ? (
                  <div
                    type="invalid"
                    style={{
                      fontSize: "10px",
                      color: "red",
                    }}
                  >
                    {errors?.flightLegs?.return[0]?.departureTime}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            <Col xs="12" md="12" className="mb-2">
              <Form.Group controlId="formBasicEmail">
                <Form.Label>
                  PNR <span className="text-danger">*</span>
                </Form.Label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="PNR"
                  name={`flightLegs.return[${0}].pnr`}
                  value={values?.flightLegs?.return[0]?.pnr}
                  onChange={handleChange}
                />
                {touched?.flightLegs?.return &&
                errors?.flightLegs?.return &&
                touched?.flightLegs?.return[0]?.pnr &&
                errors?.flightLegs?.return[0]?.pnr ? (
                  <div
                    type="invalid"
                    style={{
                      fontSize: "10px",
                      color: "red",
                    }}
                  >
                    {errors?.flightLegs?.return[0]?.pnr}{" "}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            <Col xs="12" md="6">
              <Form.Group controlId="formBasicEmail">
                <Form.Label>
                  First Name <span className="text-danger">*</span>
                </Form.Label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="First Name"
                  name={`pax.return[${modalIndex}].fN`}
                  value={values?.pax?.return[modalIndex]?.fN}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    handleChange(e);
                    setFieldValue(`pax.return[${modalIndex}].fN`, newValue);
                  }}
                />
                {touched?.pax?.return &&
                errors?.pax?.return &&
                touched?.pax?.return[modalIndex]?.fN &&
                errors?.pax?.return[modalIndex]?.fN ? (
                  <div
                    type="invalid"
                    style={{
                      fontSize: "10px",
                      color: "red",
                    }}
                  >
                    {errors?.pax?.return[modalIndex]?.fN}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            <Col xs="12" md="6">
              <Form.Group controlId="formBasicEmail">
                <Form.Label>
                  Last Name <span className="text-danger">*</span>
                </Form.Label>
                <input
                  style={{ marginTop: -3 }}
                  className="form-control"
                  type="text"
                  placeholder="Last Name"
                  name={`pax.return[${modalIndex}].lN`}
                  value={values?.pax?.return[modalIndex]?.lN}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    handleChange(e);
                    setFieldValue(`pax.return[${modalIndex}].lN`, newValue);
                  }}
                />
                {touched?.pax?.return &&
                errors?.pax?.return &&
                touched?.pax?.return[modalIndex]?.lN &&
                errors?.pax?.return[modalIndex]?.lN ? (
                  <div
                    type="invalid"
                    style={{
                      fontSize: "10px",
                      color: "red",
                    }}
                  >
                    {errors?.pax?.return[index]?.lN}
                  </div>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>
            {/* No Change Error */}
            {noChangeError && (
              <Col xs="12">
                <div style={{ color: "red", fontSize: 12 }}>
                  Please change at least one value
                </div>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Continue
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaxCard;
